import { create } from "zustand";
import type { DownPaymentSourceEnum } from "../interfaces/mortgageDetailsInterface";

interface DownPaymentSource {
  source: DownPaymentSourceEnum;
  amount: string;
}

interface DownPaymentStore {
  sources: DownPaymentSource[];
  isValidationTriggered: boolean;
  addSource: (source: DownPaymentSourceEnum) => void;
  removeSource: (source: DownPaymentSourceEnum) => void;
  updateAmount: (source: DownPaymentSourceEnum, amount: string) => void;
  validateSources: () => boolean;
  resetValidation: () => void;
}

const useDownPaymentStore = create<DownPaymentStore>()((set, get) => ({
  sources: [],
  isValidationTriggered: false,

  addSource: (source) =>
    set((state) => ({
      sources: [...state.sources, { source, amount: "" }],
      isValidationTriggered: false,
    })),

  removeSource: (source) =>
    set((state) => ({
      sources: state.sources.filter((s) => s.source !== source),
      isValidationTriggered: false,
    })),

  updateAmount: (source, amount) =>
    set((state) => ({
      sources: state.sources.map((s) =>
        s.source === source ? { ...s, amount } : s
      ),
    })),

  validateSources: () => {
    const allValid = get().sources.every((s) => s.amount.trim() !== "");
    set({ isValidationTriggered: true });
    return allValid;
  },

  resetValidation: () => set({ isValidationTriggered: false }),
}));

export { useDownPaymentStore };
